import { useEffect } from 'react';
import { motionReduced } from './motion';

/** ボタンの押した場所と、ネイティブ入力検証の失敗を一か所で扱う。 */
export function FeedbackEvents() {
  useEffect(() => {
    const press = (event: PointerEvent) => {
      if (motionReduced() || event.button !== 0) return;
      const button = (event.target as Element).closest<HTMLElement>('.btn');
      if (!button || button.matches(':disabled') || button.closest('fieldset:disabled')) return;
      const bounds = button.getBoundingClientRect();
      const ripple = document.createElement('span');
      ripple.className = 'feedback-ripple';
      const size = Math.hypot(bounds.width, bounds.height) * 2;
      ripple.style.width = ripple.style.height = `${size}px`;
      ripple.style.left = `${event.clientX - bounds.left - size / 2}px`;
      ripple.style.top = `${event.clientY - bounds.top - size / 2}px`;
      button.append(ripple);
      setTimeout(() => ripple.remove(), 300);
    };
    const shake = (element: Element) => {
      if (motionReduced() || !(element instanceof HTMLElement)) return;
      element.classList.remove('feedback-shake');
      void element.offsetWidth;
      element.classList.add('feedback-shake');
      setTimeout(() => element.classList.remove('feedback-shake'), 300);
    };
    const invalid = (event: Event) => {
      if (event.target instanceof Element) shake(event.target);
    };
    const errors = new MutationObserver((records) => {
      const affected = new Set<Element>();
      for (const record of records) {
        if (
          record.type === 'attributes' &&
          record.target instanceof Element &&
          record.target.matches('[aria-invalid="true"]')
        )
          affected.add(record.target);
        for (const node of record.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('.alert.danger, .toast.error, [role="alert"]')) affected.add(node);
          node
            .querySelectorAll('.alert.danger, .toast.error, [role="alert"]')
            .forEach((element) => affected.add(element));
        }
        if (record.target instanceof Element) {
          const alert = record.target.closest('.alert.danger, [role="alert"]');
          if (alert) affected.add(alert);
        }
      }
      affected.forEach(shake);
    });
    errors.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-invalid'],
    });
    document.addEventListener('pointerdown', press);
    document.addEventListener('invalid', invalid, true);
    return () => {
      errors.disconnect();
      document.removeEventListener('pointerdown', press);
      document.removeEventListener('invalid', invalid, true);
    };
  }, []);
  return null;
}
